"use client";
import React from "react";
import styles from "./Button.module.css";
import classNames from "classnames";
import { ThreeDots } from "react-loader-spinner";

const cx = classNames.bind(styles);

type ButtonProps = {
  children: React.ReactNode;
  disabled?: boolean;
  isLoading?: boolean;
  className?: string;
  variant?: "ghost";
} & React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

const Button = (props: ButtonProps) => {
  const { className, children, disabled, isLoading } = props;

  const button_styles = cx({
    [styles.button]: true,
    [styles.disabled]: disabled,
    [className || ""]: !!className,
    [styles.ghost]: props.variant === "ghost",
  });

  return (
    <button {...props} className={button_styles}>
      {isLoading ? (
        <ThreeDots
          data-testid="three-dots-loading"
          height="24"
          width="32"
          radius="8"
          color="#fff"
          ariaLabel="three-dots-loading"
          wrapperStyle={{}}
          visible={true}
        />
      ) : (
        children
      )}
    </button>
  );
};

export default Button;
